import React from 'react';
import * as Style from './style';
import Car from '../../../img/car3.png';

const Banner = () => (
	<Style.BannerBackground>
		<Style.Banner>
			<div className="row">
				<div className="col-12">
					<div className="row">
						<div className="col-12">
							<Style.Title>
								Em breve!<br />
								Um serviço de Campanhas da Webmotors para você.
							</Style.Title>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Style.Text>
								Todos os recursos que o lojista ou concessionária<br />
								precisam para dar um gás nas vendas!
							</Style.Text>
						</div>
					</div>
				</div>
			</div>
		</Style.Banner>
		<div className="d-flex justify-content-center align-items-center">
			<img src={Car} alt="BgCar" />
		</div>
	</Style.BannerBackground>
);

export default Banner;
